import radio from '../assets/radio.webp'
import ster from '../assets/ster-right.webp'
import teamAbout from '../assets/teamAbout.webp'
import deols from '../assets/ext-1.webp'

export default function AboutHero(props) {
    const { isEnglish } = props

    return (
        <div className="overflow-hidden bg-white">
            <div className="mx-auto max-w-7xl lg:flex">
                <div className="mx-auto grid max-w-xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
                    <div className="px-6 sm:px-12 lg:col-end-1 lg:w-full lg:max-w-2xl sm:pb-8">
                        <span className="inline-flex items-center rounded-full bg-brand-50 px-3 py-1.5 text-xs font-semibold text-brand-700 ring-1 ring-inset ring-brand-700/10 mb-4">
                            NEOMED
                        </span>
                        <h1 className="mt-0 sm:mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{isEnglish ? 'A new generation of dental clinics in France' : 'Une Nouvelle Génération de cabinets dentaires en France'}</h1>
                        <p className="mt-6 text-sm sm:text-lg leading-7 text-gray-600">
                            {isEnglish ?
                                "Neomed was founded in 2022 with the goal of providing unique opportunities to foreign dentists in France and address the shortage of qualified practitioners in the country. We support our doctors every step of the way, from learning French to discovering the region and starting a new life and career here."
                                :
                                "Neomed a été fondée en 2022 avec l'objectif de créer de nouvelles opportunités pour les dentistes en France tout en participant à améliorer l'accés aux soins dans notre pays. Nous aidons nos praticiens à toutes les étapes de leur installation : découverte de la région, installation, début d'activité et formation continue."
                            }
                        </p>
                        <p className="mt-2 sm:mt-4 text-sm sm:text-lg leading-7 text-gray-600">
                            {isEnglish ?
                                "Our clinics are located in the Center of France, in and around our home base of Châteauroux. 2h away from Paris, the region has a superior quality of life, plenty of patients and strong tax incentives for new practitioners."
                                :
                                "Nos cabinets sont situés dans le Centre de la France, autour de la ville de Châteauroux. A 2h de Paris à peine, la région offre une excellente qualité de vie, des patients nombreux et fidèles ainsi que l'opportunité de faire une vraie différence et progresser dans son exercice."
                            }
                        </p>
                        <div className="mt-6 flex">
                            <div
                                onClick={() => props.anchorScroll('#contact-form')}
                                className="inline-flex items-center rounded-xl bg-gray-900 px-5 py-3 text-sm sm:text-md font-semibold text-white shadow-sm cursor-pointer transition-all duration-200 hover:bg-brand-600 hover:scale-[1.02]"
                            >
                                {isEnglish ? 'Join the team' : "Rejoignez nous"}<span className="ml-2" aria-hidden="true">&rarr;</span>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
                        <div className="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                            <img
                                alt=""
                                src={teamAbout}
                                className="aspect-[7/5] w-[20rem] sm:w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover object-left-bottom shadow-lg"
                            />
                        </div>
                        <div className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
                            <div className="order-first -ml-36 sm:ml-0 flex w-64 flex-none justify-end self-end lg:w-auto">
                                <img
                                    alt=""
                                    src={ster}
                                    className="aspect-[4/3] w-[16rem] sm:w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover object-left-bottom shadow-lg"
                                />
                            </div>
                            <div className="translate-x-4 sm:translate-x-0 flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                                <img
                                    alt=""
                                    src={radio}
                                    className="aspect-[7/5] w-[20rem] sm:w-[37rem] max-w-none -translate-x-20 sm:translate-x-0 flex-none rounded-2xl bg-gray-50 object-cover shadow-lg"
                                />
                            </div>
                            <div className="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                                <img
                                    alt=""
                                    src={deols}
                                    className="aspect-[4/3] w-[14rem] sm:w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover shadow-lg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
